import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-4column 32",
  "use": "icon-4column 32-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-4column 32\"><path d=\"M234.666667 853.333333a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h554.666666a64 64 0 0 1 64 64v554.666666a64 64 0 0 1-64 64H234.666667z m96-618.666666H234.666667v554.666666h96V234.666667z m149.333333 0h-85.333333v554.666666h85.333333V234.666667z m149.333333 0h-85.333333v554.666666h85.333333V234.666667z m160 0h-96v554.666666H789.333333V234.666667z\" p-id=\"8159\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol